export const PAGE_SIZE: number = 10;

export const PAGE_SIZE_FOR_VR_USERS: number = 10;

export const LIMIT_FOR_ALL_ITEMS: number = 10000;
